(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["featured-collection"] && !window.DesignMode) return;
  try {
    
const slider2 = tns({
  arrowKeys: true,
  mouseDrag: true,
  container: '.featured-collection-products',
  controls: false,
  nav: true,
  navPosition: 'bottom',
  speed: 1000,
    items: 2,
    gutter: 16,
    responsive: {
      540: {
        gutter: 32,
        items: 3
      },
      900: {
        items: 5
      }
    }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["look-book-aw"]) return;
  try {
    
mediumZoom(document.querySelectorAll('[data-zoomable]'), {
  margin: 24,
  background: '#f4f4f4'
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["look-book-ss"]) return;
  try {
    
mediumZoom(document.querySelectorAll('[data-zoomable]'), {
  margin: 24,
  background: '#f4f4f4'
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-alt-product-template"]) return;
  try {
    
const productImages = document.querySelectorAll('.p-image-item')
if (productImages.length > 1) {
  var slider = tns({
    arrowKeys: true,
    arrows: true,
    container: '#product-images',
    controlsContainer: '#product-images-controls',
    items: 1,
    mode: 'gallery',
    navAsThumbnails: true,
    navContainer: '#product-images-thumbnails',
    speed: 1000
  })
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-look-book"]) return;
  try {
    
mediumZoom(document.querySelectorAll('[data-zoomable]'), {
  margin: 24,
  background: '#f4f4f4'
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-stockists"]) return;
  try {
    
(function () {
  var headings = document.querySelectorAll('.stockists-list h2')
  Array.prototype.forEach.call(headings, function (heading) {
    heading.innerHTML = '\n <button aria-expanded="false" class="toggle">\n' + heading.textContent + '\n <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="24" height="24">\n <rect class="vert" height="16" width="2" y="0" x="7"/>\n <rect height="2" width="16" y="7" x="0"/>\n </svg>\n </button>\n'
    var getContent = function getContent (elem) {
      var elems = []
      while (elem.nextElementSibling && elem.nextElementSibling.tagName !== 'H2') {
        elems.push(elem.nextElementSibling)
        elem = elem.nextElementSibling
      }
      elems.forEach(function (node) {
        node.parentNode.removeChild(node)
      })
      return elems
    }
    var contents = getContent(heading)
    var wrapper = document.createElement('div')
    wrapper.className = 'section-group'
    wrapper.hidden = true
    contents.forEach(function (node) {
      wrapper.appendChild(node)
    })
    heading.parentNode.insertBefore(wrapper, heading.nextElementSibling)
    var btn = heading.querySelector('button')
    btn.onclick = function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true' || false
      btn.setAttribute('aria-expanded', !expanded)
      wrapper.hidden = expanded
    }
  })
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-template"]) return;
  try {
    
const productImages = document.querySelectorAll('.p-image')
if (productImages.length > 1) {
  var slider = tns({
    arrowKeys: true,
    arrows: true,
    container: '#product-images',
    controlsContainer: '#product-images-controls',
    items: 1,
    mode: 'gallery',
    navAsThumbnails: true,
    navContainer: '#product-images-thumbnails',
    speed: 1000
  })
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read base URL from data attribute
  var baseUrl = productRecommendationsSection.dataset.baseUrl;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};

// Listen for changes done in the Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !window.DesignMode) return;
  try {
     const slider = tns({ arrowKeys: true, container: '#hero', controls: false,
items: 1, mode: 'gallery', nav: true, navPosition: 'bottom', speed: 1000 }) 
  } catch(e) { console.error(e); }
})();
      })();
